import { EMBEDDING_PRICE_KEY, type TokenPriceKey, type TokenPrices, type UsageProviderTokens } from '@rp/contracts'
import { USAGE_COPY } from './copy'

const TOKENS_PER_PRICE_UNIT = 1_000_000
const SMALLEST_SHOWN_USD = 0.01
const USD_DECIMALS = 2

export type CostEstimate = {
  monthCostUsd: number
  pricedTokens: number
  unpricedTokens: number
  budgetCostUsd: number | null
}

export const priceKeyOf = (provider: UsageProviderTokens['provider']): TokenPriceKey => provider ?? EMBEDDING_PRICE_KEY

export const estimateCost = (
  byProvider: readonly UsageProviderTokens[],
  prices: TokenPrices,
  monthlyTokenBudget: number,
): CostEstimate => {
  const priced = byProvider.flatMap((row) => {
    const price = prices[priceKeyOf(row.provider)]
    return price === undefined ? [] : [{ tokens: row.tokens, cost: (row.tokens * price) / TOKENS_PER_PRICE_UNIT }]
  })
  const pricedTokens = priced.reduce((sum, row) => sum + row.tokens, 0)
  const monthCostUsd = priced.reduce((sum, row) => sum + row.cost, 0)
  const usedTokens = byProvider.reduce((sum, row) => sum + row.tokens, 0)
  return {
    monthCostUsd,
    pricedTokens,
    unpricedTokens: usedTokens - pricedTokens,
    budgetCostUsd: pricedTokens === 0 ? null : (monthlyTokenBudget * monthCostUsd) / pricedTokens,
  }
}

const usdOf = (amount: number): string => USAGE_COPY.usd(amount.toFixed(USD_DECIMALS))

export const formatUsd = (amount: number): string =>
  amount > 0 && amount < SMALLEST_SHOWN_USD ? USAGE_COPY.costUnderMinimum(usdOf(SMALLEST_SHOWN_USD)) : usdOf(amount)
